import React, { Component } from "react";

import ContractClassifyCommon from "./ContractClassifyCommon";
import ContractClassifyNursery from "./ContractClassifyNursery";

class ContractClassify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataYears: null,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setData(nextProps.bizYear, nextProps.chartData);
  };

  setData = (year, chartData) => {
    var data =
      chartData && chartData.statClassify ? chartData.statClassify : null;
    var contractAgeList = [];
    var contractYearList = [];
    var contractNurseryTypeList = [];
    var contractNurseryTypeListFlat = [];
    if (data && data.age && data.age.length > 0) {
      data.age.forEach((d) => {
        var stat = null;
        if (d.age == "123") {
          stat = { name: "혼합", value: d.cnt };
        } else {
          stat = { name: `${d.age + 2}세`, value: d.cnt };
        }
        var dataYear = contractAgeList.find((a) => a.year == d.year);
        if (dataYear) {
          dataYear.stat.push(stat);
        } else {
          contractAgeList.push({ year: d.year, stat: [stat] });
        }
      });
    }
    if (data && data.years && data.years.length > 0) {
      var longTermLimit = 4;
      data.years.forEach((d) => {
        const yearName =
          d.years >= longTermLimit
            ? `${longTermLimit}년 이상`
            : (d.years <= 0 ? `1년차` : `${d.years}년차`);
        var dataYear = contractYearList.find((a) => a.year == d.year);
        if (dataYear) {
          var dataYearStat = dataYear.stat.find((s) => s.name == yearName);
          if (dataYearStat) {
            dataYearStat.cnt += d.cnt;
          } else {
            dataYear.stat.push({ name: yearName, value: d.cnt });
          }
        } else {
          contractYearList.push({
            year: d.year,
            stat: [{ name: yearName, value: d.cnt }],
          });
        }
      });
    }
    if (data && data.nurseryType && data.nurseryType.length > 0) {
      data.nurseryType.forEach((d) => {
        var dataYearFlat = contractNurseryTypeListFlat.find((a) => a.year == d.year);
        if(dataYearFlat) {
          var dataYearStat = dataYearFlat.stat.find((s) => s.type == d.type && s.name == d.subType);
          if (dataYearStat) {
            dataYearStat.cnt += d.cnt;
          } else {
            dataYearFlat.stat.push({ type: d.type, stack: d.type === "S" ? "유치원" : (d.type === "A" ? "어린이집" : "기타"), name: d.subType ? d.subType : "기타", value: d.cnt });
          }
        } else {
          contractNurseryTypeListFlat.push({
            year: d.year,
            stat: [{ type: d.type, stack: d.type === "S" ? "유치원" : (d.type === "A" ? "어린이집" : "기타"), name: d.subType ? d.subType : "기타", value: d.cnt }],
          });
        }
        var dataYear = contractNurseryTypeList.find((a) => a.year == d.year);
        if (dataYear) {
          var type = dataYear.stat.find((n) => n.type == d.type);
          if (type) {
            type.children.push({
              name: d.subType ? d.subType : "기타",
              value: d.cnt,
            });
          } else {
            dataYear.stat.push({
              type: d.type,
              name: d.type === "S" ? "유치원" : (d.type === "A" ? "어린이집" : "기타"),
              children: [
                {
                  name: d.subType ? d.subType : "기타",
                  value: d.cnt,
                },
              ],
            });
          }
        } else {
          contractNurseryTypeList.push({
            year: d.year,
            stat: [
              {
                type: d.type,
                name: d.type === "S" ? "유치원" : (d.type === "A" ? "어린이집" : "기타"),
                children: [
                  {
                    name: d.subType ? d.subType : "기타",
                    value: d.cnt,
                  },
                ],
              },
            ],
          });
        }
      });
    }

    this.setState({
      dataAge: contractAgeList,
      dataYears: contractYearList,
      dataNurseryType: contractNurseryTypeList,
      dataNurseryTypeFlat: contractNurseryTypeListFlat
    });
  };

  render() {
    const { bizYear, chartData } = this.props;
    var isKeezle = chartData ? chartData.id == 'keezle' : false;
    const colClass = isKeezle ? "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" : "col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12";
    const titleYAxis = isKeezle ? "계약(건)" : "클래스(건)";
    const { dataAge, dataYears, dataNurseryType, dataNurseryTypeFlat } = this.state;
    return (
      <>
        <div className="row">
          {!isKeezle && <div className={colClass}>
            <ContractClassifyCommon
              title="연령"
              year={bizYear}
              data={dataAge}
              height={150}
            />
          </div>}
          <div className={colClass}>
            <ContractClassifyCommon
              title="계약 연차"
              year={bizYear}
              data={dataYears}
              titleYAxis={titleYAxis}
              height={150}
            />
          </div>
          <div className={colClass}>
            <ContractClassifyNursery
              title="원"
              year={bizYear}
              selectedApp={chartData}
              data={dataNurseryType}
              dataFlat={dataNurseryTypeFlat}
              titleYAxis={titleYAxis}
              height={350}
            />
          </div>
        </div>
      </>
    );
  }
}

export default ContractClassify;
